<template >
    <div class="container-fluid" v-if="marchand">
        <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px;margin-top:10px" title="Retour"><v-icon>mdi mdi-arrow-left</v-icon> Retour</v-btn>
        <v-row>
            <v-col cols="4">
                <v-card style="padding: 15px;"  class="background-linear">
                    <div class="row card-details">
                        <div class="col-md-12 pt-2 pb-0"><v-icon large >mdi-home</v-icon></div>
                        <div class="col-md-12 ">
                            <div>{{this.$t('marchand.company')}} : </div>
                            <div style="font-weight: bold;color: #29B3A6 !important;">{{marchand._company}}  </div>
                        </div>
                    </div>
                </v-card>
            </v-col>
             <v-col v-if="marchand.wallet" cols="4">
              <v-card style="padding: 15px;"  class="background-linear">
                  <div class="row card-details">
                     <div class="col-md-12 pt-2 pb-0"><v-icon large >mdi-cash-multiple</v-icon></div>
                     <div class="col-md-12 ">
                         <div>Portefeuille disponible: </div>
                         <div style="font-weight: bold">{{marchand.wallet._amount}} {{marchand.wallet.devise._code_alpha}}</div>
                     </div>
                  </div>

              </v-card>
            </v-col>
              <v-col v-if="marchand.wallet" cols="4">
              <v-card style="padding: 15px;"  class="background-linear">
                  <div class="row card-details">
                     <div class="col-md-12 pt-2 pb-0"><v-icon large >mdi-cash</v-icon></div>
                     <div class="col-md-12 ">
                         <div>Portefeuille en attente: </div>
                         <div style="font-weight: bold">
                             <span>
                             {{marchand.wallet._waiting_amount}} {{marchand.wallet.devise._code_alpha}}
                             </span>
                             <button v-if="parseInt(marchand.wallet._waiting_amount) > 0" @click="updateWalletByPendingData()" class="float-right btn btn-sm btn-primary">valider</button>
                             </div>
                     </div>
                  </div>

              </v-card>
            </v-col>

             <v-col  cols="4">
              <v-card style="padding: 15px;" >
                  <div class="row card-details">
                     <div class="col-md-12 pt-2 pb-0"><v-icon large >mdi-credit-card</v-icon> Moyen de paiement</div>
                     <div class="col-md-12 ">
                         <div  class="authors-container" data-collaborators="2">
                             <div  v-if="marchand._usermeanspaiement">
                                 <div v-if="marchand._usermeanspaiement.length===0">
                                     <div  style="font-weight: bold;">
                                         Aucun
                                     </div>
                                 </div>
                                 <div v-else  class="author" v-for="(means,index) in marchand._usermeanspaiement" :key="index">
                                     <a class=" account-photo  account-product-owner ">
                                         <div class="mask">
                                             <img :src="'../'+means._means_paiement._file" alt="">
                                         </div>
                                     </a>
                                 </div>
                             </div>

                           </div>
                     </div>
                  </div>

              </v-card>
            </v-col>

        </v-row>
        <v-row>
            <v-col >
                <div  v-if="marchand._valide===false && marchand._reason">
                    <v-alert   style="padding: 15px;margin: 10px"   dense outlined :type="(errors && errors.update_error)? 'error':'error'"> {{$t('marchand.rejet')}} {{marchand._reason}}</v-alert>
                </div>
                <div v-if="marchand._valide===true && documents">
                    <v-alert v-if="(documents && documents.user_valid ) ?  documents.user_valid._first_name && documents.user_valid._last_name : '-'"  style="padding: 15px;margin: 10px"   dense outlined :type="(errors && errors.update_error)?'error':'success'"> {{$t('documents.valide_date')}} {{ new Date(documents._valide_date).toLocaleDateString()}} par {{ documents.user_valid._first_name}} {{ documents.user_valid._last_name}}</v-alert>
                    <v-alert v-else  style="padding: 15px;margin: 10px"   dense outlined :type="(errors && errors.update_error)?'error':'success'"> {{$t('documents.valide_date')}} {{ new Date(documents._valide_date).toLocaleDateString()}} par {{ documents.user_valid._email}}</v-alert>
                </div>
                <v-alert  v-if="errors"  dense outlined :type="(errors && errors.update_error)?'error':'success'">{{$t(errors.message)}}</v-alert>
                <v-text-field  v-if="submitting" color="primary" loading disabled></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-card>
                    <h4 style="padding: 18px;font-weight: bold" class="background-tb">Informations</h4>
                    <table style="width: 100%" class="p-3 table table-striped">
                        <tbody>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.user')}}:</td>
                            <td >{{marchand._user_id._email}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> Pays:	</td>
                            <td class="text-lowercase">{{marchand.country._name}}</td>

                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.site_web')}}:</td>
                            <td>{{marchand._web_site}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.acronyme')}}:</td>
                            <td>{{marchand._acronyme}}</td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.email')}}:</td>
                            <td >{{marchand._email}} </td>
                        </tr>
                        <tr style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.categorie')}}:</td>
                            <td>{{marchand._categorie_id._name}}</td>
                        </tr>
                        <tr v-if="marchand._url_success" style="padding: 15px" >
                            <td style="padding: 15px">{{ this.$t('marchand.url_success')}}:</td>
                            <td>{{marchand._url_success}}</td>
                        </tr>
                        <tr v-else style="padding: 15px" >
                            <td style="padding: 15px">{{ this.$t('marchand.url_success')}}:</td>
                            <td>---</td>
                        </tr>
                        <tr v-if="marchand.url_checkout" style="padding: 15px" >
                            <td style="padding: 15px">{{ this.$t('marchand.url_checkout')}}:</td>
                            <td>{{marchand.url_checkout}}</td>
                        </tr>
                        <tr v-else style="padding: 15px" >
                            <td style="padding: 15px">{{ this.$t('marchand.url_checkout')}}:</td>
                            <td>---</td>
                        </tr>
                        <tr v-if="marchand.url_error" style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.url_error')}}:</td>
                            <td>{{marchand.url_error}}</td>
                        </tr>
                        <tr v-else style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.url_error')}}:</td>
                            <td>---</td>
                        </tr>
                        <tr v-if="marchand._base_url_site_web" style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.base_url')}}:</td>
                            <td>{{marchand._base_url_site_web}}</td>
                        </tr>
                        <tr v-else style="padding: 15px" >
                            <td style="padding: 15px"> {{this.$t('marchand.base_url')}}:</td>
                            <td>---</td>
                        </tr>
                        </tbody>
                    </table>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card>
                    <h4 style="padding: 18px;font-weight: bold" class="background-tb">Documents</h4>
                    <div v-if="documents">
                        <table style="width: 100%" class="p-3 table table-striped">
                            <tbody >
                            <tr v-if="documents._numCard" style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.num_card')}}:</td>
                                <td>{{documents._numCard}}</td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.num_card')}}:</td>
                                <td>---</td>
                            </tr>
                            <tr v-if="documents._fileCard" style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.file')}}:</td>
                                <td>
                                    <a :href="base+documents._fileCard" target="_blank">
                                       Pièce d"identité
                                    </a>
                                </td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.file')}}:</td>
                                <td>---</td>
                            </tr>
                            <tr v-if="documents._numRCCM" style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.num_rccm')}}:</td>
                                <td>{{documents._numRCCM}}</td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.num_rccm')}}:</td>
                                <td>---</td>
                            </tr>
                            <tr v-if="documents._fileRCCM" style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.file_rccm')}}:</td>
                                <td>
                                    <a :href="base+documents._fileRCCM" target="_blank">
                                       Document RCCM
                                    </a>
                                </td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.file_rccm')}}:</td>
                                <td>---</td>
                            </tr>
                            <tr v-if="documents._numIFU" style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.num_ifu')}}:</td>
                                <td>{{documents._numIFU}}</td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.num_ifu')}}:</td>
                                <td>---</td>
                            </tr>
                            <tr v-if="documents._fileIFU" style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.file_ifu')}}:</td>
                                <td>
                                    <a :href="base+documents._fileIFU" target="_blank">
                                        Document IFU
                                    </a>
                                </td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> {{$t('documents.file_ifu')}}:</td>
                                <td>---</td>
                            </tr>
                            <tr v-if="documents._valide_date" style="padding: 15px" >
                                <td style="padding: 15px"> Validé le :</td>
                                <td>{{ new Date(documents._valide_date).toLocaleDateString()}}</td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> Validé:</td>
                                <td>---</td>
                            </tr>
                            <tr v-if="documents.user_valid" style="padding: 15px" >
                                <td style="padding: 15px"> Validé par :</td>
                                <td v-if="documents.user_valid._first_name && documents.user_valid._last_name">{{ documents.user_valid._first_name}}{{ documents.user_valid._last_name}}</td>
                                <td v-else>{{ documents.user_valid._email}}</td>
                            </tr>
                            <tr v-else style="padding: 15px" >
                                <td style="padding: 15px"> Validé par:</td>
                                <td>---</td>
                            </tr>
                            </tbody>
                        </table>
                        <v-row>
                            <v-col  style="margin-top: 2%;">
                                <v-btn v-if="marchand._valide===false" @click="valider(marchand._id,documents._id)"  class="float-right" color="primary" >{{$t('documents.valider')}}</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else>
                        <v-card-title>
                            <v-col cols="12" sm="12"
                                   md="12" class="text-lg-center" style="font-weight: bold;font-size: 18px">
                                AUCUN DOCUMENT
                            </v-col>
                        </v-card-title>

                    </div>

                </v-card>
            </v-col>

        </v-row>

        </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from '../../mixins/helpers'
    import $ from 'jquery'
import { locale } from 'moment';

    $.fn.scrollToTop = function (speed) {
        if (typeof(speed) === 'undefined')
            speed = 1000;

        $('html, body').animate({
            scrollTop: parseInt($(this).offset().top)
        }, speed);
    };
    export default {
        label: "Transactions",
        mixins:[helpers(this)],
        data () {
            return {
                filter:'',
                date: new Date().toISOString().substr(0, 10),
                transactions_tabs:'',
                errors:undefined,
                submitting:false,
                base: process.env.FILE_BASE_URL_DOC,
                generaldatas:{},
                search: '',
                dialog: '',
                id:undefined,

            }
        },
        computed: {
            ...mapState('marchands/',['marchand']),
            ...mapState('wallets/',['wallet']),
            ...mapState('generalsettings/',['generals','generalmarchands']),
            ...mapState('documents/',['documents']),
            ...mapState('user_means_paiements/',['user_means_paiements']),
        },
        mounted(){
            this.initialize();
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            updateWalletByPendingData(){
                let VueBox = this;
                this.$store.dispatch('wallets/updateWalletByPendingData',{marchandId:this.$route.params.id}).then((response)=>{
                    if(response.data.error){
                       VueBox.toast('error',this.$t(response.data.message));
                    }else{
                       VueBox.toast('success',this.$t(response.data.message));
                    setTimeout(function(){
                        location.reload();
                    },2000)
                    }
                })
            },
            initialize(){
                this.$store.dispatch('marchands/getmarchandDetails',this.$route.params.id)
                this.$store.dispatch('wallets/getwallet',this.$route.params.id)
                this.$store.dispatch('documents/getDocument',this.$route.params.id)
                let data = new FormData();
                data.append("id",this.$route.params.id);
                this.$store.dispatch('user_means_paiements/getUser_means_paiements',data)
            },
            valider (id,doc) {
                let VueBox = this;
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text:   this.$t('marchand.valider'),
                    confirmButtonText:"Oui,valider",
                    cancelButtonText: "Non, Refusé",
                    showCancelButton: true,
                    confirmButtonColor:'#29B3A6'

                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('documents/validDocument', {id:id,doc:doc}).then((result) => {
                            if (result.error) {
                                this.submitting = false;
                                VueBox.toast('error',this.$t(result.message));

                            }
                            else{
                                this.submitting = false;
                                VueBox.toast('success',this.$t(result.message));
                                this.initialize();
                            }
                        });
                       /* this.showSnackDefault(result);
                        this.initialize();*/
                        //this.$router.push({ path: '/list_marchands' })


                    }
                    else{

                        Swal.fire({
                            title:this.$t('marchand.raison') ,
                            input: 'textarea',
                            inputAttributes: {
                                autocapitalize: 'off'
                            },
                            showCancelButton: true,
                            confirmButtonText:"Envoyer",
                            cancelButtonText: this.$t('cancel'),
                            cancelButtonColor:"#CCC",
                            confirmButtonColor:'#29B3A6',
                            showLoaderOnConfirm: true,
                            preConfirm: (reason) => {
                                let data = {reason:reason,id:id}
                                this.submitting = true;
                                return this.$store.dispatch('marchands/rejet',data).then((result) => {
                                    if (result.error) {
                                        this.submitting = true;
                                        VueBox.toast('error',this.$t(result.message));
                                    }
                                    else{
                                        this.submitting = true;
                                        VueBox.toast('success',this.$t(result.message));
                                        this.initialize();
                                    }
                                    //this.$router.push({ path: '/list_marchands' })



                                })

                            },
                            allowOutsideClick: () => !Swal.isLoading()
                        }).then((result) => {
                            if (result.value) {
                                Swal.fire({
                                    text: VueBox.$t(result.value.message),
                                })
                            }
                        })
                    }
                });

            },
            getStatusColor(status){
                let response = {};
                switch (status) {
                    case process.env.VUE_APP_STATUS_ERROR:
                        response.color = 'red';
                        response.status = 'échec';
                        break;
                        case process.env.VUE_APP_STATUS_PENDING:
                            response.color = 'orange';
                            response.status = 'en attente';
                            break;
                            case process.env.VUE_APP_STATUS_SUCCESS:
                                response.color = 'success';
                                response.status = 'succès';
                                break;
                                default:
                                    response.color = 'dark';
                                    response.status = 'defaut';
                                    break;
                }
                return response;
            },
        },
        created() {
            this.checkisDashboard();
        },

    }
</script>

<style scoped>
    .circular--square {
        border-radius: 50%;
    }
    .circular--square {
        border-radius: 50% 50%;
        width: 170px;
        height: 170px;
        object-fit: contain;
    }
.action-inputs-group{
    margin-left: 1%;
}
    h2{
        color: #1C3071;
    }
    .actions-inputs{
        display: inline-block;
        margin: 15px;
    }
</style>
